import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { ContratistaService } from 'src/app/services/contratista.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { LoginService } from 'src/app/services/login.service';

import { TIPOS_DE_VIA, IVA, PRECIO_UNITARIO_AMPLIADA, PRECIO_UNITARIO_AMPLIADA_IVA, PRECIO_UNITARIO_BASICA, PRECIO_UNITARIO_BASICA_IVA } from './../../../constants/constants';
import { ValidacionesService } from 'src/app/services/validaciones.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { AUTONOMIAS, PROVINCIAS, MUNICIPIOS } from './../../../constants/constants';

@Component({
  selector: 'app-new-perfil-contratista',
  templateUrl: './new-perfil-contratista.component.html',
  styleUrls: ['./new-perfil-contratista.component.scss']
})
export class NewPerfilContratistaComponent implements OnInit {

  public userLogged: any

  isLinear = false;
  firstPage: any= {};
  secondPage: any= {};
  thirdPage: any;
  tiposVia?: String[]; 

  precio: any
  precioContratista: any

  public nombreComercial: any;
  public contactos: any;
  public nombreContacto: any;
  public mailContacto: any
  contratista:any

  public addContacts?: boolean;
  public contactsFirstStep?: boolean= true

  public newContratista: any;
  public oldContratista: any;

  newsletter:any
  customId:any

  iva: number
  precioAmpliada: number
  precioAmpliadaIva: number
  precioBasica: number
  precioBasicaIva: number
  precioBasicaIvaShow: any
  precioAmpliadaIvaShow: any
  facturas:any=[]
  idFactura:any
  precioContratistaFront:any
  autonomias:any
  provincias:any
  municipios:any
  autonomia:any
  provincia:any
  municipio:any
  tipoPago: any
  precioTpv:any
  importe: any
  facturaId:any
  contratistaId:any
  button:any = false

  @ViewChild('buttonContainer') buttonContainer: any;

  constructor(private formBuilder: FormBuilder, private apollo: Apollo, private loginService: LoginService,
    private contratistaService: ContratistaService, private userService: UsuariosService, private validacionService:ValidacionesService,private facturaService: FacturacionService) {
      this.tiposVia = TIPOS_DE_VIA
      this.iva = IVA;
      this.precioAmpliada = PRECIO_UNITARIO_AMPLIADA;
      this.precioAmpliadaIva = PRECIO_UNITARIO_AMPLIADA_IVA;
      this.precioAmpliadaIvaShow = this.precioAmpliadaIva.toFixed(2).toString().replace(/\./g,',');;
      this.precioBasica = PRECIO_UNITARIO_BASICA;
      this.precioBasicaIva = PRECIO_UNITARIO_BASICA_IVA;
      this.precioBasicaIvaShow = this.precioBasicaIva.toFixed(2).toString().replace(/\./g,',');
      this.userLogged = loginService.getUserData()
      this.autonomias = AUTONOMIAS
      
      
     }


  ngOnInit(){
    if (this.userLogged.contratista != null) {
      this.getContratistaById()
    }
    
    
     
   
    this.buildForm()
    this.getAllContratistas()
 

  this.thirdPage.valueChanges.subscribe((val: any) => {
      /* console.log(val) */
    })
  }

  selectAutonomia(e:any){
    this.provincias = PROVINCIAS
    if (e) {
      this.provincias = this.provincias.filter((provincia:any)=> provincia.COMUNIDAD_AUTONOMA == e.value )
      this.autonomia = e.value
    }
  }

  selectProvincia(e:any){
    this.municipios = MUNICIPIOS
    if (e) {
      this.municipios = this.municipios.filter((municipio:any)=> municipio.PROVINCIA_ID== e.value.ID )
      this.provincia = e.value.NOMBRE
    }
  }

  selectMunicipio(e:any){
    this.municipio = e.value.NOMBRE
  }


   private buildForm(){
    this.firstPage = this.formBuilder.group({
      razonSocial: ['', [Validators.required]],
      nombreComercial: ['',[Validators.required]],
      cif: ['', [Validators.required, this.validCif()]],
      via: ['', [Validators.required]],
      nombreVia: ['',[Validators.required]],
      numeroVia: ['', [Validators.required]],
      planta: [''],
      letra: [''],
      localidad: ['',[Validators.required]],
      provincia: ['',[Validators.required]],
      codigoPostal: ['',[Validators.required]],
      ccaa: ['',[Validators.required]],
      actividadEmpresa: ['',[Validators.required]],
    });

    this.secondPage = this.formBuilder.group({
      nombreContacto:['', [Validators.required]],
      mailContacto:['', [Validators.required]],
      
    });
    this.thirdPage = this.formBuilder.group({
      numeroLicencias: ['', [Validators.required]],
      policy: ['', [Validators.required]],
      pago: ['', [Validators.required]],
      newsletter: ['']
    })
  }



  getContratistaById(){

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": this.userLogged.contratista?.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.oldContratista = data.contratista
        this.contratista = data.contratista
        this.displayOldContratista()
        if (this.contratista.xtensaBasica == true){
         
          setTimeout(() => {
          this.precio= (this.contratista.numeroInvitacion * this.precioBasicaIva).toFixed(2).toString().replace(/\./g,',')
          const invitacion = data.contratista.facturas.filter((factura:any)=> factura.estado == "invitacion"); 
          this.idFactura = invitacion[0]?.id
          console.log(this.contratista.numeroInvitacion);
          console.log(this.precioBasica);
          
         const precioTpv = (this.contratista.numeroInvitacion * this.precioBasicaIva)
          this.getFacturaById(precioTpv)
         }, 1000);

        }
        const invitacion = data.contratista.facturas.filter((factura:any)=> factura.estado == "invitacion"); 
        this.idFactura = invitacion[0]?.id
       
        
      })
  }

  async getFacturaById(importe:any) {
   
    this.apollo.watchQuery<any>({
      query: this.facturaService.getFacturaById(),
      variables: {
        "id": this.idFactura
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       
       
        
      importe = importe.toFixed(2)
      console.log(importe);
      
        
        this.importe = importe;
        this.contratistaId = data.factura.contratista.id
        this.facturaId = data.factura.id
        
       
        }
      )
  }



  selectPrecio() {
    const e = this.thirdPage.value.numeroLicencias
    this.precioContratista= (e * this.precioAmpliadaIva)
    this.precioContratistaFront = (e * this.precioAmpliadaIva).toFixed(2).toString().replace(/\./g,',')
    this.getFacturaById(this.precioContratista)
  } 

  getAllContratistas(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getAllContratistas(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      console.log(data)
        if (data.contratistas[0] == undefined) {
          this.customId = 1
        }else{
          this.customId = data.contratistas[data.contratistas.length-1].customID + 1
        }
      })
  }


  validCif(){
    return (control: AbstractControl):{[key: string]: boolean} | null=>{
    
    
   let cif:any = control.value
  
      if(this.validacionService.checkCif(cif) == false){
      
        return {'validCif':true}
      }
    return null;
    }
  }

  displayOldContratista(){
    if(this.firstPage){
      this.firstPage.reset()
    }

    this.firstPage.patchValue({
      nombreComercial: this.oldContratista.nombreComercial,
      razonSocial: this.oldContratista.razonSocial,
      cif: this.oldContratista.cif,
      via: this.oldContratista.direccion?.tipoVia,
      nombreVia: this.oldContratista.direccion?.nombre,
      actividadEmpresa: this.oldContratista?.actividad,
      numeroVia: this.oldContratista.direccion?.numero,
      planta: this.oldContratista.direccion?.planta,
      letra: this.oldContratista.direccion?.letra,
      localidad: this.oldContratista.direccion?.localidad,
      provincia: this.oldContratista.direccion?.provincia,
      codigoPostal:this.oldContratista.direccion?.codigoPostal,
      ccaa:this.oldContratista.direccion?.ccaa,
    })

    this.secondPage.patchValue({
      nombreContacto: this.oldContratista.contactoResponsable?.nombre,
      mailContacto: this.oldContratista.contactoResponsable?.mail,
    })

    this.thirdPage.patchValue({
      numeroLicencias: this.oldContratista.numeroInvitacion
      
    })
  }

  setContratista(){
    this.newContratista = {...this.oldContratista, ...this.firstPage.value}
    /* console.log(this.newContratista) */
  }

  setContratista2(){
    this.newContratista = {...this.newContratista, ...this.secondPage.value}
    /* console.log(this.newContratista) */
  }
  setNewsletter(e:any){
    if(e.target.checked) this.newsletter = e.target.checked
  }
  
  updateContratistaById(){
    this.setContratista()
    
    
    this.newContratista = {...this.newContratista, ...this.thirdPage.value}

    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.userLogged.contratista.id
          },
          "data": {
            "razonSocial": this.newContratista.razonSocial,
            "nombreComercial": this.newContratista.nombreComercial,
            "cif": this.newContratista.cif,
            "direccion": {
              "tipoVia": this.newContratista.via,
              "nombre": this.newContratista.nombreVia,
              "numero": this.newContratista.numeroVia,
              "pta": this.newContratista.planta,
              "letra": this.newContratista.letra,
              "localidad": this.municipio,
              "provincia": this.provincia,
              "codigoPostal": this.newContratista.codigoPostal,
              "ccaa": this.autonomia
            },
            "actividad": this.newContratista.actividadEmpresa,
            "contactoResponsable": {
              "mail": this.newContratista.mailContacto,
              "nombre": this.newContratista.nombreContacto,
            },
            "numeroInvitacion": this.newContratista.numeroLicencias,
            "newsletter": this.newsletter,
            "identificadorCO": "CO",
            "customID": this.customId,
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        this.updateUser()
        this.selectPrecio()
      }, (error) => {
        /* console.log('aaaaa',error) */
      })
  }

  updateUser(){
      this.apollo.mutate({
      mutation: this.userService.updateUsuario(),
      variables: {
        "input": {
          "where": {
            "id": this.userLogged.id
          },
          "data": {
            "name": this.newContratista.nombreContacto,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
       console.log(data);
       
      }, (error) => {
        /* console.log('aaaaa',error) */
      })
  }


  handleAddContactos(e: Event){
    this.contactsFirstStep = false;
    this.addContacts = true;
    /* console.log(this.contactsFirstStep) */
  }

  setAddContactsFalse(){
    this.addContacts = false
    this.contactsFirstStep = true;
  }

  setPolicy(e:any){
    if(e.target.checked){
      if(this.thirdPage.value.pago == 'tarjeta') {
        this.setTipoPago("tarjeta")
      }else{
        this.setTipoPago("transferencia")
      }
      
      this.button = true;
      
    } 
    else this.button = false
  }

  setTipoPago(e:any){

    if (e == "tarjeta" || e == "transferencia") {
      this.tipoPago = e;
    }else{
      this.tipoPago = e.target.value
    }

    
    let formData = new FormData();
 
   
       
        formData.append('importe', this.importe)
        formData.append('idContratista', this.contratistaId)
        formData.append('idFactura', this.facturaId)
        if (this.contratista.xtensaBasica) {
         formData.append('numLicencias', this.contratista.numeroInvitacion) 
        } else {
         formData.append('numLicencias', this.thirdPage.value.numeroLicencias)
        }
      
     
        if (this.tipoPago == "tarjeta") {

          
            fetch('https://tpv.inpsolutions.com/tpv/index.php', {
        method: 'POST',
        body: formData
        }).then(function (response) {
        return response.text();
        }).then((html) => {

       
        this.buttonContainer.nativeElement.innerHTML = html;
    
        }).catch(function (err) {
       
        console.warn('error.', err);
        }); 
        }
/* NO HAY TRANSFERENCIAS FEBRERO 20222 */
    /*     if (this.tipoPago == "transferencia") {
          console.log(this.tipoPago);
          fetch('https://tpv.inpsolutions.com/pisp/index.php', {
      method: 'POST',
      body: formData
      }).then(function (response) {
      return response.text();
      }).then((html) => {

     
      this.buttonContainer.nativeElement.innerHTML = html;
  
      }).catch(function (err) {
     
      console.warn('error.', err);
      }); 
      } */
  }

}
